var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('ul',_vm._l((_vm.items),function(item,idx){return _c('li',{key:idx},[_vm._t("content",null,{"data":item})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }